export const formatDate = (date: string | Date | undefined) =>
new Date(`${date?.toLocaleString().replace(/-/g, "/")} 12:00:00`).toLocaleDateString("pt-BR", {
  timeZone: "America/Sao_Paulo",
});
